import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'

export const BannerContainer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme?.colors.semantic.demoAccountBanner};
    padding: 16px 24px;
    border-radius: 2px;
    min-height: 48px;
    margin: 35px 0;
`

export const BannerText = styled(Typography)<{ theme?: TTheme }>`
    color: ${({ theme }) => theme?.colors.greys[800]};
    margin-left: 12px;
`
